import classNames from 'classnames';
import React, { useMemo } from 'react';
import EyedropperIcon from '../../../assets/svg/eyedropper.svg?react';

import styles from './FJEyedropper.module.less';
import FJUtil from '../../../util/FJUtil';
import FJButton from '../FJButton/FJButton';
import FJConfig from '../../../config/FJConfig.js';

const FJEyedropper = props => {
    const { className, callback } = props;
    const cn = classNames(styles.box, className);

    // 判断当前是否是支持的浏览器
    const _isSupportBrowser = () => {
        const browser = FJUtil.getBrowser();
        return FJConfig.eyedropperSupportBrowser.indexOf(browser) !== -1;
    };

    const _handleClick = async () => {
        const eyeDropper = new window.EyeDropper();
        try {
            const result = await eyeDropper.open(); // 开始拾取颜色
            if (callback) {
                callback(result.sRGBHex);
            }
        } catch (e) {
            // 取消取色
        }
    };

    const createEyedropper = useMemo(() => {
        if (_isSupportBrowser()) {
            return (
                <FJButton
                    onClick={_handleClick}
                    className={cn}
                    icon={<EyedropperIcon />}
                    tooltip={'pick-a-color-from-the-design'}
                />
            );
        } else {
            null;
        }
    }, []);

    return createEyedropper;
};

export default FJEyedropper;
